import { gql } from '@apollo/client';

export const EnrichmentsFragment = gql`
  fragment Enrichments on Enrichments {
    investment_stage
    sector
    fit_score {
      score
      reason
    }
    usp
    key_technologies
    patents
    founders {
      name
      role
      degree
    }
  }
`;

/*
export const EnrichmentsFragment = gql`
  fragment Enrichments on Enrichments {
    id
    investment_stage
    key_technologies
    patents
    usp
    sector
    fit_score {
      score
      reason
    }
    founders {
      name
      role
      degree
    }
  }
`;
*/
